import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useCMS } from '../context/CMSContext';
import { aboutSection as defaultAbout } from '../data/mockData';

const AboutSection = () => {
  const { get } = useCMS();
  const data = get('about') || defaultAbout;

  return (
    <section className="relative py-24 lg:py-32 bg-[#050914] border-t border-white/5" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="inline-flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-white/50 font-bold mb-6">
            <span className="w-8 h-px bg-white/30" />
            {data.eyebrow || 'About Digitize'}
          </p>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tighter text-white leading-[1.05]">
            {data.heading}
          </motion.h2>
        </div>
        <div className="lg:col-span-7 space-y-8">
          {(data.paragraphs || []).map((p, i) => (
            <motion.p key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              className="text-white/60 text-base lg:text-lg font-light leading-relaxed">
              {p}
            </motion.p>
          ))}
          <div className="grid sm:grid-cols-3 gap-4 pt-6 border-t border-white/5">
            {(data.pillars || []).map((pillar, i) => (
              <motion.div key={pillar.id}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ delay: 0.2 + i * 0.08, duration: 0.5 }}
                className="p-5 rounded-xl border border-white/8">
                <div className="flex items-center gap-2 mb-2">
                  <Check className="w-4 h-4 text-[#FF6B35]" />
                  <p className="font-display text-lg text-white">{pillar.title}</p>
                </div>
                <p className="text-sm text-white/50 font-light">{pillar.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
